"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonModelRequestDTOFields = exports.CommonModelDTOFields = exports.CommonMongoModelFields = void 0;
var zod_1 = require("zod");
var ObjectId_1 = require("./ObjectId");
exports.CommonMongoModelFields = {
    _id: zod_1.z.instanceof(ObjectId_1.ObjectId),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
};
exports.CommonModelDTOFields = {
    _id: (0, ObjectId_1.ObjectIdString)('Invalid _id'),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
};
exports.CommonModelRequestDTOFields = {
    _id: (0, ObjectId_1.ObjectIdString)('Invalid _id').optional(),
    createdAt: zod_1.z.coerce.date().optional(),
    updatedAt: zod_1.z.coerce.date().optional(),
};
//# sourceMappingURL=CommonMongoModelFields.js.map